import { isown, symbolsof, valueof } from "~/utils/iterate-object/object";

export function* iterateObjectValue(o: any) {
	for (const key in o) {
		const value = valueof(o, key);
		if (!isown(o, key)) {
			continue;
		}

		yield [key, value] as const;
	}

	for (const symbol of symbolsof(o)) {
		const value = valueof(o, symbol);
		yield [symbol, value] as const;
	}
}
